import { request } from '@/api';
import type { UserInfo } from '@/types/common';

const PREFIX = '/user';

export type ChangePasswordData = {
  /**
   * 确认密码
   */
  confirmPassword: string;
  /**
   * 新密码
   */
  newPassword: string;
  /**
   * 风险操作验证获取的临时令牌
   */
  token: string;
};

export type BindEmailData = {
  /**
   * 邮箱
   */
  email: string;
  /**
   * 邮箱验证码
   */
  emailCode: string;
  /**
   * 风险操作验证获取的临时令牌
   */
  token: string;
};

export type BindPhoneData = {
  /**
   * 手机号
   */
  phone: string;
  /**
   * 手机号验证码
   */
  smsCode: string;
  /**
   * 风险操作验证获取的临时令牌
   */
  token: string;
};

/**
 * 获取用户信息
 */
export const getUserInfo = () => {
  return request.get<UserInfo>(`${PREFIX}/detail`);
};

/**
 * /nickname/change
 * 变更昵称
 */
export const changeNickname = (nickname: string) => {
  return request.post(`${PREFIX}/nickname/change`, { nickname });
};

/**
 * /password/change
 * 修改密码
 */
export const changePassword = (data: ChangePasswordData) => {
  return request.post(`${PREFIX}/password/change`, data);
};

/**
 * /email/bind
 * 绑定邮箱
 */
export const bindEmail = (data: BindEmailData) => {
  return request.post(`${PREFIX}/email/bind`, data);
};

/**
 * /email/bind/code/send
 * 发送邮箱验证码
 * @param token 风险操作验证获取的临时令牌
 * @param email 待绑定邮箱
 */
export const sendBindEmailCode = (token: string, email: string) => {
  return request.post(`${PREFIX}/email/bind/code/send`, { token, email });
};

/**
 * /phone/bind
 * 绑定手机号
 */
export const bindPhone = (data: BindPhoneData) => {
  return request.post(`${PREFIX}/phone/bind`, data);
};

/**
 * /phone/bind/code/send
 * 发送手机号验证码
 * @param token 风险操作验证获取的临时令牌
 * @param phone 待绑定手机号
 */
export const sendBindPhoneCode = (token: string, phone: string) => {
  return request.post(`${PREFIX}/phone/bind/code/send`, { token, phone });
};